import { useToast } from '@/hooks/useToast';
import { useNotificationChannel } from './NotificationChannelContext';
import { useEffect } from 'react';
import { StudioVideoStatus } from '@/features/ai-video-creator/stores/studioVideoStore';
import { MediaAssetStatus, MediaAssetType, GenerationInstrument } from '@/types/media';
import { PersonalAvatarStatus } from '@/types/avatar';

export const NotificationChannelToast = () => {
  const { notify, notifyError } = useToast();
  const notificationChannel = useNotificationChannel();
  useEffect(() => {
    const unsubscribeStudioVideoGeneration = notificationChannel.subscribe('studio-video-generation', (data) => {
      switch (data.status) {
        case StudioVideoStatus.PROCESSING:
          notify('Generation started');
          break;
        case StudioVideoStatus.DONE:
          notify('Video generated');
          break;
      }
    });
    const unsubscribeMediaAssetGeneration = notificationChannel.subscribe('media-asset-generation', (data) => {
      if (data.instrumentsWithModifiers?.[0]?.instrument === GenerationInstrument.chatToImage) {
        return;
      }
      let asset = 'Video';
      switch (data.type) {
        case MediaAssetType.image:
          asset = 'Image';
          break;
        case MediaAssetType.audio:
          asset = 'Audio';
          break;
        case MediaAssetType.video:
        default:
          asset = 'Video';
          break;
      }
      switch (data.status) {
        case MediaAssetStatus.PROCESSING:
          notify('Generation started');
          break;
        case MediaAssetStatus.DONE:
          notify(`${asset} generated`);
          break;
      }
    });
    const unsubscribePersonalAvatarGeneration = notificationChannel.subscribe('personal-avatar-generation', (data) => {
      switch (data.status) {
        case PersonalAvatarStatus.PROCESSING:
          notify('Generation started');
          break;
        case PersonalAvatarStatus.DONE:
          notify('Influencer generated');
          break;
      }
    });
    return () => {
      unsubscribeStudioVideoGeneration();
      unsubscribeMediaAssetGeneration();
      unsubscribePersonalAvatarGeneration();
    };
  }, []);
  return null;
};
